import { Icon } from "@repo/ui/components/icon";
import { cn } from "@repo/ui/lib/utils";

function Spinner({
  className,
  ...props
}: Omit<React.ComponentProps<"svg">, "name">) {
  return (
    <Icon
      name="spinner"
      role="status"
      aria-label="Loading"
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  );
}

export { Spinner };
